import {
  StyleSheet,
} from 'react-native';
import { primaryFont500 } from './Common';

export default (direction) => StyleSheet.create({
  controlsTopRow: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: 33,
    flexDirection: 'row',
    margin: 18,
    marginRight: 6,
    paddingRight: direction === 'column' ? 0 : 20,
  },
  controlContainer: {
    // borderColor: '#ccc',
    // borderWidth: 1,
    borderRadius: 16,
    overflow: 'hidden',
    marginRight: 12,
  },
  languageControl: {
    padding: 8,
    paddingTop: 7,
    paddingHorizontal: 12,
    backgroundColor: 'white',
    justifyContent: 'center',
    alignSelf: 'flex-end',
    fontSize: 14,
    textAlignVertical: 'center',
    textAlign: 'center',
    fontFamily: primaryFont500,
    fontWeight: '500',
  },
  mapTypeControl: {
    padding: 8,
    paddingTop: 7,
    paddingHorizontal: 12,
    backgroundColor: 'white',
    justifyContent: 'center',
    alignSelf: 'flex-end',
    fontSize: 14,
    textAlignVertical: 'center',
    textAlign: 'center',
    fontFamily: primaryFont500,
    fontWeight: '500',
  },
});
